import type { ConnectorResp } from '@repositories/subscriptionConnectionRepository/subscriptionConnection.types';
import { ConnectorActionModel } from './ConnectorActionModel';

export class ConnectorRespModel {
  private readonly _dto: ConnectorResp;
  private readonly _actions: ConnectorActionModel[];

  constructor(dto: ConnectorResp) {
    this._dto = dto;
    this._actions = dto.actions?.length ? dto.actions.map(action => new ConnectorActionModel(action)) : [];
  }

  get originDTO(): ConnectorResp {
    return this._dto;
  }

  get addUserSchema() {
    return this._dto.addUserSchema;
  }

  get connectionInfoSchema() {
    return this._dto.connectionInfoSchema || '';
  }

  get connectionInfoSchemaJson() {
    return JSON.parse(this._dto.connectionInfoSchema || '');
  }

  get actions() {
    return this._actions;
  }

  get id() {
    return this._dto.id || '';
  }

  get name() {
    return this._dto.name || '';
  }

  get productCode() {
    return this._dto.productCode || '';
  }

  get targetClass() {
    return this._dto.targetClass || '';
  }

  get type() {
    return this._dto.type || 'JAVASCRIPT';
  }
}
